import { TableRowActionsMenu } from '@dealstack/frontend/shared/components/TableRowActionsMenu/TableRowActionsMenu.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useMemo } from 'react';
import { TableRowActionOption } from '@dealstack/frontend/shared/components/TableRowActionsMenu/TableRowActionsMenu.types';

interface Props {
	onKycClick: () => void;
	onInvestorDataClick: () => void;
	onTaxComplianceClick?: () => void;
	onInviteClick: () => void;
	onRevokeClick: () => void;
	onReleaseClick: () => void;
	onVestingTermsClick: () => void;
	isCompleted: boolean;
	disableInvite: boolean;
	disableVestingTerms: boolean;
	isEligibleForRelease: boolean;
}

export const InvestmentRowActions = ({
	onKycClick,
	onInvestorDataClick,
	onTaxComplianceClick,
	onInviteClick,
	onRevokeClick,
	onReleaseClick,
	onVestingTermsClick,
	isCompleted,
	disableInvite,
	disableVestingTerms,
	isEligibleForRelease,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	const options: TableRowActionOption[] = useMemo(
		() => [
			{
				label: tMipManage('investors.actions.release'),
				onClick: onReleaseClick,
				disabled: isCompleted || !isEligibleForRelease,
			},
			{
				label: tMipManage('investors.expanded_row.revoke'),
				onClick: onRevokeClick,
				disabled: isCompleted,
			},
			{
				label: tMipManage('investors.actions.send_invite'),
				onClick: onInviteClick,
				disabled: isCompleted || disableInvite,
			},
			{
				label: tMipManage('investments.actions.investor_data_requirements'),
				onClick: onInvestorDataClick,
				disabled: isCompleted,
			},
			{
				label: tMipManage('investments.actions.kyc_requirements'),
				onClick: onKycClick,
				disabled: isCompleted,
			},
			...(onTaxComplianceClick
				? [
						{
							label: tMipManage('investments.actions.tax_and_compliance'),
							onClick: onTaxComplianceClick,
							disabled: isCompleted,
						},
					]
				: []),
			{
				label: tMipManage('investors.actions.vesting_terms'),
				onClick: onVestingTermsClick,
				disabled: disableVestingTerms,
			},
		],
		[
			tMipManage,
			onReleaseClick,
			onRevokeClick,
			onInviteClick,
			onInvestorDataClick,
			onKycClick,
			onTaxComplianceClick,
			onVestingTermsClick,
			isCompleted,
			disableInvite,
			disableVestingTerms,
			isEligibleForRelease,
		]
	);

	return <TableRowActionsMenu options={options} />;
};
